(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-featured-tabs]').forEach(function (group) {
      var tabs = group.querySelectorAll('.featured-tabs__tab');
      var panels = group.querySelectorAll('.featured-tabs__panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.getAttribute('data-tab-index');
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          tab.classList.add('is-active');
          var panel = group.querySelector('[data-panel-index="' + idx + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const openBtn = document.querySelector('.mobile-menu-button');
    const drawer = document.querySelector('.mobile-drawer');
    const backdrop = document.querySelector('.mobile-drawer-backdrop');
    const logo = document.querySelector('.header__logo');
    const header = document.querySelector('header');
    const html = document.documentElement;
    const infoBar = document.querySelector('.info-bar-section');

    let lastScrollY = 0;
    let ticking = false;

    function updateLogoOnScroll() {
      if (!logo) return;
      if (lastScrollY > 50) {
        logo.classList.add('header--scrolled');
        header.classList.add('header--scrolled');
        html.classList.add('header--scrolled');
        if (infoBar) infoBar.classList.add('header--scrolled');
      } else {
        logo.classList.remove('header--scrolled');
        header.classList.remove('header--scrolled');
        html.classList.remove('header--scrolled');
        if (infoBar) infoBar.classList.remove('header--scrolled');
      }
    }

    function onScroll() {
      lastScrollY = window.scrollY || window.pageYOffset;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateLogoOnScroll();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    let windowWidth = window.innerWidth;

    window.addEventListener('resize', () => {
      windowWidth = window.innerWidth;
      if (windowWidth >= 750) {
        closeDrawer();
      }
    });

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('drawer-open');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('drawer-open');
    }

    // Toggle drawer when hamburger is clicked (open/close)
    if (openBtn)
      openBtn.addEventListener('click', function () {
        if (drawer && drawer.classList.contains('open')) closeDrawer();
        else openDrawer();
      });
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    // Accordion toggles
    document.querySelectorAll('.drawer-accordion .accordion-toggle').forEach((btn) => {
      btn.addEventListener('click', function () {
        const li = btn.closest('.drawer-accordion');
        const panel = li.querySelector('.accordion-panel');
        const expanded = li.classList.toggle('open');
        if (expanded) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
          panel.style.maxHeight = null;
        }
      });
    });

    // Dropdown -> toggle header.dropdown-open when any dropdown is hovered or focused
    (function () {
      const headerEl = document.querySelector('header');
      if (!headerEl) return;
      document.querySelectorAll('.dropdown-parent').forEach((parent) => {
        parent.addEventListener('mouseenter', () => headerEl.classList.add('dropdown-open'));
        parent.addEventListener('mouseleave', () => headerEl.classList.remove('dropdown-open'));
        parent.addEventListener('focusin', () => headerEl.classList.add('dropdown-open'));
        parent.addEventListener('focusout', () => headerEl.classList.remove('dropdown-open'));
      });
    })();

    // Ensure dropdowns always sit flush below the header by updating a CSS var
    (function () {
      const headerEl = document.querySelector('header');
      if (!headerEl) return;

      function updateHeaderHeight() {
        const h = Math.ceil(headerEl.getBoundingClientRect().height);
        headerEl.style.setProperty('--header-height', h + 'px');
      }

      // Initialize
      updateHeaderHeight();

      // Debounced resize handler
      let resizeTimer = null;
      window.addEventListener('resize', function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateHeaderHeight, 120);
      });

      // Observe header size changes (logo swap, font loading, etc.)
      if (window.ResizeObserver) {
        const ro = new ResizeObserver(updateHeaderHeight);
        ro.observe(headerEl);
      } else {
        window.addEventListener('scroll', updateHeaderHeight, { passive: true });
      }
    })();

    // Search Modal
    (function () {
      const searchModal = document.getElementById('searchModal');
      const searchInput = document.getElementById('searchModalInput');
      const searchToggleBtns = document.querySelectorAll('.search-toggle');
      const searchModalClose = document.querySelector('.search-modal-close');
      const searchModalOverlay = document.querySelector('.search-modal-overlay');
      const suggestionsList = document.getElementById('suggestionsList');
      const productsList = document.getElementById('productsList');
      const suggestionsSection = document.getElementById('searchSuggestions');
      const productsSection = document.getElementById('searchProducts');
      const noResultsSection = document.getElementById('searchNoResults');
      const searchSubmitBtn = document.getElementById('searchSubmitBtn');
      const searchQuery = document.getElementById('searchQuery');
      let searchTimeout;

      if (!searchModal) {
        console.warn('Search modal element not found');
        return;
      }

      console.log('Search modal initialized, found', searchToggleBtns.length, 'toggle buttons');

      // Open modal
      function openSearchModal(e) {
        if (e) e.preventDefault();
        console.log('Opening search modal');
        console.log('Modal element:', searchModal);
        console.log('Modal children:', searchModal.children);
        console.log('Modal content element:', document.querySelector('.search-modal-content'));
        const modalContent = document.querySelector('.search-modal-content');
        if (modalContent) {
          console.log('Modal content dimensions:', {
            width: modalContent.offsetWidth,
            height: modalContent.offsetHeight,
            display: window.getComputedStyle(modalContent).display,
            position: window.getComputedStyle(modalContent).position,
            zIndex: window.getComputedStyle(modalContent).zIndex,
            visibility: window.getComputedStyle(modalContent).visibility,
            opacity: window.getComputedStyle(modalContent).opacity,
          });
        }
        console.log('Modal before add class:', searchModal.className);
        searchModal.classList.add('active');
        console.log('Modal after add class:', searchModal.className);
        console.log('Modal display:', window.getComputedStyle(searchModal).display);
        console.log('Modal visibility:', window.getComputedStyle(searchModal).visibility);
        console.log('Modal z-index:', window.getComputedStyle(searchModal).zIndex);
        searchModal.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        setTimeout(() => {
          if (searchInput) searchInput.focus();
          console.log('Modal after timeout:', window.getComputedStyle(searchModal).display);
          if (modalContent) {
            console.log('Modal content after timeout:', {
              width: modalContent.offsetWidth,
              height: modalContent.offsetHeight,
              display: window.getComputedStyle(modalContent).display,
              zIndex: window.getComputedStyle(modalContent).zIndex,
            });
          }
        }, 100);
      }

      // Close modal
      function closeSearchModal() {
        console.log('Closing search modal');
        searchModal.classList.remove('active');
        console.log('Modal display after removing active:', window.getComputedStyle(searchModal).display);
        searchModal.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (searchInput) searchInput.value = '';
        suggestionsSection.style.display = 'none';
        productsSection.style.display = 'none';
        noResultsSection.style.display = 'none';
        searchSubmitBtn.style.display = 'none';
      }

      // Add click listeners to all search toggle buttons
      searchToggleBtns.forEach((btn) => {
        btn.addEventListener('click', openSearchModal);
        console.log('Added click listener to search button');
      });

      // Close modal
      if (searchModalClose) searchModalClose.addEventListener('click', closeSearchModal);
      if (searchModalOverlay) searchModalOverlay.addEventListener('click', closeSearchModal);

      // Keyboard navigation
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && searchModal.classList.contains('active')) {
          closeSearchModal();
        }
      });

      // Search input
      if (searchInput) {
        searchInput.addEventListener('input', function (e) {
          const query = e.target.value.trim();
          if (searchQuery) searchQuery.textContent = query;

          clearTimeout(searchTimeout);

          if (!query) {
            suggestionsSection.style.display = 'none';
            productsSection.style.display = 'none';
            noResultsSection.style.display = 'none';
            searchSubmitBtn.style.display = 'none';
            return;
          }

          searchTimeout = setTimeout(() => {
            performSearch(query);
          }, 300);

          // Always show the submit button with current query
          searchSubmitBtn.style.display = 'block';
        });
      }

      // Perform search
      function performSearch(query) {
        // Clear previous results
        suggestionsList.innerHTML = '';
        productsList.innerHTML = '';

        console.log('Searching for:', query);

        // Use Shopify's search API
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=3`)
          .then((response) => {
            console.log('Search response status:', response.status);
            return response.json();
          })
          .then((data) => {
            console.log('Search API response:', data);

            // Parse the response - check different possible structures
            let products = [];
            let suggestions = [];

            if (data.resources && data.resources.results && data.resources.results.products) {
              products = data.resources.results.products;
            } else if (data.resources && data.resources.results) {
              products = data.resources.results;
            } else if (data.products) {
              products = data.products;
            }

            if (data.resources && data.resources.results && data.resources.results.queries) {
              suggestions = data.resources.results.queries;
            }

            console.log('Found products:', products.length);
            console.log('Found suggestions:', suggestions.length);

            if (suggestions.length === 0 && products.length === 0) {
              noResultsSection.style.display = 'block';
              suggestionsSection.style.display = 'none';
              productsSection.style.display = 'none';
              return;
            }

            noResultsSection.style.display = 'none';

            // Display suggestions
            if (suggestions.length > 0) {
              suggestionsSection.style.display = 'block';
              suggestionsList.innerHTML = suggestions
                .map(
                  (suggestion) =>
                    `<li><a href="/search?q=${encodeURIComponent(suggestion.text || suggestion)}">${
                      suggestion.styled_text || suggestion.text || suggestion
                    }</a></li>`
                )
                .join('');
            } else {
              suggestionsSection.style.display = 'none';
            }

            // Display products
            if (products.length > 0) {
              productsSection.style.display = 'block';
              productsList.innerHTML = products
                .map((product) => {
                  const imageUrl =
                    product.image || (product.featured_image && product.featured_image.url) || product.featured_image;
                  const image = imageUrl ? `<img src="${imageUrl}" alt="${product.title}">` : '';
                  const price = product.price
                    ? `<span class="product-price">from $${parseFloat(product.price).toFixed(2)} USD</span>`
                    : '';
                  return `
                    <li class="product-item">
                      <a href="${product.url}">
                        <div class="product-image">${image}</div>
                        <div class="product-info">
                          <div class="product-title">${product.title}</div>
                          ${price}
                        </div>
                      </a>
                    </li>
                  `;
                })
                .join('');
            } else {
              productsSection.style.display = 'none';
            }
          })
          .catch((error) => {
            console.error('Search error:', error);
            noResultsSection.style.display = 'block';
          });
      }

      // Search submit button
      if (searchSubmitBtn) {
        searchSubmitBtn.addEventListener('click', function () {
          const query = searchInput.value.trim();
          if (query) {
            window.location.href = '/search?q=' + encodeURIComponent(query);
          }
        });
      }
    })();
  });

  } catch(e) { console.error(e); }
})();
})();
